<template>
  <div class="qyjs_box">

   <div>
	 <router-view></router-view>
   </div>
    <div class="box">
		<!-- <div style="background-color: #fff;border-radius: 10px;padding: 20px;margin-bottom: 20px;font-size: 16px;font-weight: bold;margin-top: 20px;">一分一段</div> -->
		<div class="boxA">
			<div class="box-tit"><span>一分一段</span></div>
			<!-- <div class="search-t">
				<el-input  placeholder="请输入院校名称" v-model="queryParams.schoolName"  class="input-with-select" clearable>
					<el-button type="danger" slot="append" icon="el-icon-search" @click="schGet">搜索</el-button>
				</el-input>
			</div> -->
			
			<el-form :model="queryParams" ref="queryForm" size="small" :inline="true" class="topsec" @submit.native.prevent>
				<el-row :gutter="24">
					<el-col :span="24">
						<el-form-item label="所在地区:" label-width="80px">
							<!-- <el-radio-group v-model="queryParams.schoolCityOne" :max="3" @change="" >
								<el-radio-button v-for="item in filtrate.F" :label="item.name"
									:key="item.name">{{ item.name }}</el-radio-button>
							</el-radio-group> -->
							<div class="kuai">
								<span v-for="item in filtrate.F" :label="item.name" :key="item.name" :class="queryParams.cityId==item.id?'onsele':''" @click="clickA(item)">{{ item.name }}</span>
							</div>
						</el-form-item>
					</el-col>
				</el-row>
				 <el-row :gutter="28">
					<el-col :span="28">
						<el-form-item label="批次:" label-width="80px">
							<div class="kuai">
								<span v-for="item in filtrate.A"   :class="queryParams.batchId==item.id?'onsele':''" @click="clickB(item)">{{ item.name }}</span>
							</div>
						</el-form-item>
					</el-col>
				</el-row>
				
				<el-row :gutter="28">
					<el-col :span="28">
						<el-form-item label="年份:" label-width="80px">
							<div class="kuai">
								<span v-for="item in filtrate.C"   :class="queryParams.year==item.year?'onsele':''" @click="clickC(item)">{{ item.year }}</span>
							</div>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="28">
					<el-col :span="28">
						<el-form-item label="类别:" label-width="80px">
							<div class="kuai">
								<span v-for="item in filtrate.D"   :class="queryParams.record==item.record?'onsele':''" @click="clickD(item)">{{ item.record }}</span>
							</div>
						</el-form-item>
					</el-col>
				</el-row>
				
			</el-form>
		</div>
			<!-- 学校列表 -->
		<div class="schmain">
			 
			 <div class="admit-scoreLine-box-table" v-if="schList&&schList.length">
			 	<div class="admit-scoreLine-box-table-th" style="height: 100rpx;display: flex;background: #F5FAFE;width: 100%;height: 50px;line-height: 50px;">
			 		<div class="admit-scoreLine-box-table-th-div table-lt" style="flex:1;">
			 			分数
			 		</div>
			 		<div class="admit-scoreLine-box-table-th-div "style="flex: 1;" v-if="batchName=='普通类'">
			 			同分人数
			 		</div>
			 		<div class="admit-scoreLine-box-table-th-div "style="flex: 1;" v-if="batchName=='普通类'">
			 			位次/区间
			 		</div>
					<div class="admit-scoreLine-box-table-th-div "style="flex: 1;" v-else>
						位次
					</div>
			 		
			 	</div>
			 	<div style="border: 1px solid #f0f0f0;">
			 		<div class="admit-scoreLine-box-table-list"
			 			v-for="(item,index) in schList" :key="index" >
			 			<div class="admit-scoreLine-box-table-list-div" style="flex:1;">
			 				{{item.score?item.score:'-'}}
			 			</div>
			 			<div class="admit-scoreLine-box-table-list-div" v-if="batchName=='普通类'">
			 				{{item.num?item.num:'-'}}
			 			</div>
			 			<div class="admit-scoreLine-box-table-list-div"  v-if="batchName=='普通类'">
			 				{{item.total}} / {{item.rankRange?item.rankRange:'-'}}
			 			</div>
						<div class="admit-scoreLine-box-table-list-div"  v-else>
							{{item.total?item.total:'-'}}
						</div>
			 		</div>
			 	</div>
			 </div>
			 
			 
			<el-empty v-else :image-size="200"></el-empty>
		</div>
	</div>
	<div ref="loadMoreTrigger" style="height: 100px;"></div>
    
  </div>
</template>

<script>
import { xuemengintro } from "@/api/intoxuemeng";
	import  {UPLODE_URL} from '@/utils/request'
export default {
  data() {
    return {
		UPLODE_URL,
		batchName:'',
      filtrate: {
      	A: [],//nianfen 
      	B: ['公办', '民办', '独立学院', '中外合作办学', '内地与港澳台地区合作办学', '境外高校独立办学'],//办学性质
      	C: ['985', '211', '研究生院', '双一流', '保研', '双高高职', '示范高职', '骨干高职'],//院校层次
      	D: [],//标签
      	E: [{ id: 1, name: '冲', num: 0 }, { id: 2, name: '稳', num: 0 }, { id: 3, name: '保', num: 0 }, { id: 4, name: '新增' }],
		F:[],
		G: ['是'],
		H: [{name:'101计划',id:'是',quer:'oneJihuas'},{name:'卓越工程师',id:'是',quer:'zuoyueJihuas'},{name:'国优计划',id:'是',quer:'youJihuas'}],
		// {name:'武书连',id:'是',quer:'wushulian'},
		J: [{name:'软科综合',id:'是',quer:'ruanke'},{name:'校友会综合',id:'是',quer:'xiaoyouhui'},{name:'QS',id:'是',quer:'QS'},{name:'US',id:'是',quer:'US'}],
      },
	  schList:[],
	  pageTotal:0,
	  busy: true,

	  // 查询参数
	  queryParams: {
	  	pageNum: 1,
	  	pageSize: 400,
		
	  	schoolName: '',//学校名
	  	schoolLevel:'',//本科和专科
	  	citySchoolIds: [],//省份id 下拉选择传
	  	majorCodeAlls: [],// //专业id 下拉选择传
	  	// majorNames: '', //专业名
	  	schoolType: '', //院校类型
	  	natureName: [], //办学性质
	  	attribute: [], //院校层次
	  	notTtile: [] ,//标签
	  	schoolCityOne:[],
	  	
	  	oneJihuas:'',
	  	zuoyueJihuas:'',
	  	youJihuas:'',
	  	
	  	ruanke:'',
	  	xiaoyouhui:'',
	  	// wushulian:'',
	  	qs:'',
	  	us:''
		
		
		
	  },
    };
  },
  directives: {
      intersect: {
        bind(el, binding) {
          const observer = new IntersectionObserver((entries, observer) => {
			  console.log('entries',entries)
            entries.forEach(entry => {
              if (entry.isIntersecting) {
                const img = entry.target;
				console.log('2222sdfsfs',img)
                // 在这里可以做图片的懒加载处理，比如更改src属性
                // img.src = img.dataset.src;
                // 或者触发其他的方法
                // binding.value(entry, observer);
                // observer.unobserve(img); // 停止观察
				// this.createObserver();
              }
            });
          });
   
          observer.observe(el);
        }
      }
    },
  created() {
    this.city();
	// this.getList()
  },
  mounted() {
  	 this.createObserver();
  },
  beforeDestroy() {
    },
  methods: {
	  // 跳转学校详情
	  goInfo(item){
		  localStorage.setItem('xiaoid',item.id)
		  this.$router.push({path:'/Ainformation/schoolInfo'})
		  return
		const route =this.$router.resolve({name:'schoolInfo',})
		localStorage.setItem('xiaoid',item.id)
		// 打开新窗口并导航至生成的URL
		window.open(route.href, '_blank');
	  },
	  handleIntersect(entry, observer){
		  console.log('11111111111111111111eee')
		  if (this.queryParams.pageNum >= this.pageTotal ) {
		  	// this.$message({
		  	//   message: '没有更多了',
		  	//   type: 'warning',
		  	//   duration: '4000'
		  	// });
		  	return
		  }
		  // this.busy = true
		  this.queryParams.pageNum++;
		  this.getBath('more')
	  },
	  createObserver() {
	        const options = {
	          root: null, // viewport
	          rootMargin: '100px',
	          threshold: 1.0
	        };
	        const observer = new IntersectionObserver(this.handleIntersect, options);
	        observer.observe(this.$refs.loadMoreTrigger);
	      },
	  creat(){
		  
	  },
	  // 获取筛选省份 然后获取批次
	   city(){
		   this.api.homeCityListShanApi().then(res => {
			   this.filtrate.F = res.data
			   this.queryParams.cityId =37
			   this.batch()
			   this.year(this.queryParams.cityId,1)
			})
	   },
	   // 获取批次
	   batch(cityId){
		   let qu={cityId: this.queryParams.cityId}
		   this.api.GetAppBatchListPcApi(qu).then(res => {
			   this.filtrate.A = res.data
			   this.batchName = res.data[0].batchName
			   this.queryParams.batchId = res.data[0].id
			   this.queryParams.typeName =  res.data[0].typeName
			})
	   },
	   // 获取年
	   year(cityId,type,year){
		   
	   		   let qu={
					cityId: this.queryParams.cityId,
					type:type,
					year:this.queryParams.year||year||''
				   }
	   		   this.api.homeBranchTypeApi(qu).then(res => {
				   
	   			   if(type==1){
					   this.filtrate.C = res.data
					   // filtrate.C
	   			   	this.queryParams.year=''
	   			   	this.queryParams.year =res.data[0].year
	   			   	this.year(this.queryParams.cityId,2,this.queryParams.year)
	   			   }
				   if(type==2){
					   this.filtrate.D = res.data
				   	this.queryParams.record=''
				   	this.queryParams.record =res.data[0].record
					// 获取列表
				   	this.getBath()
				   }
				   // this.getBath()
	   			})
	   },
	   
	   // 获取列表
	   getBath(type){
		   console.log('121111111获取列表来了 ')
		   let qu={
		   			cityId: this.queryParams.cityId,
		   			year:this.queryParams.year,
					record:this.queryParams.record,
					pageSize:this.queryParams.pageSize,
					pageNum:this.queryParams.pageNum,
					// batchId:this.queryParams.batchId ,			
					typeName:this.queryParams.typeName	
		   		}
		   
		   this.api.homeBranchListNewApi(qu).then(res => {
		   	   	if(res.code==200){
		   	   		
		   	   		if (type == 'more') {
		   	   			if (!res.data) {
		   	   				this.$message({
		   	   					message: '没有更多了',
		   	   					type: 'warning',
		   	   					duration: '4000'
		   	   				});
		   	   				return
		   	   			}
		   	   			this.schList = [...this.schList, ...res.data.rows];
		   	   			
		   	   		}else{
		   	   			this.schList = []
		   	   			this.schList = res.data ? res.data.rows : [];
		   	   			// this.dataText = res.data ? '' : '暂无数据'; //进去页面先让字样为空
		   	   			this.pageTotal = res.data ? res.data.pageTotal : 0;
		   	   		}
		   	   		
		   	   		
		   	   		// if(res.data&&res.data.rows){
		   	   		// 	this.pageTotal = res.data.pageTotal
		   	   		// 	this.schList = res.data.rows;
		   	   			
		   	   		// 	// this.schList = [...this.schList, ...res.data.rows];
		   	   			
		   	   		// }else{
		   	   		// 	this.schList = []
		   	   		// }
		   	   	}else{
		   	   		 this.$message.error(res.msg);
		   	   	}
		   	})
	   },
	   
	   
	   
	   
	   
	   
	   // 地区 点击
	   clickA(item){
		   this.queryParams.cityId = item.id
		   this.queryParams.pageNum = 1;
		  this.year(this.queryParams.cityId,1)
	   },
	   // 批次 点击
	   clickB(item){
		  this.queryParams.batchId = item.id
		  this.queryParams.typeName = item.typeName
		  this.batchName = item.batchName
		   this.queryParams.pageNum = 1;
		   this.getBath()
	   },
	   // 年份 点击
	   clickC(item){
		  this.queryParams.year = item.year
		   this.queryParams.pageNum = 1;
		  this.year(this.queryParams.cityId,2)
		  // this.getBath()
	   },
	   
	   // 院校层次 点击
	   clickD(item){
	   		this.queryParams.record = item.record
			this.queryParams.pageNum = 1;
	   		this.getBath()
	   },
	   // 院校排名 
	   clickE(item){
	   	if(item.name=='软科综合'){
	   		if(this.queryParams.ruanke == item.quer){
	   			console.log('1111111111')
	   			this.queryParams.ruanke=''
	   			return
	   		}
	   		this.queryParams.ruanke = item.quer
	   		
	   		this.queryParams.xiaoyouhui=''
	   		this.queryParams.qs=''
	   		this.queryParams.us=''
	   		
	   	}
	   	if(item.name=='校友会综合'){
	   		if(this.queryParams.xiaoyouhui == item.quer){
	   			console.log('2222222')
	   			this.queryParams.xiaoyouhui=''
	   			return
	   		}
	   		this.queryParams.xiaoyouhui = item.quer
	   		
	   		
	   		this.queryParams.ruanke = ''
	   		// this.queryParams.xiaoyouhui=''
	   		this.queryParams.qs=''
	   		this.queryParams.us=''
	   	}
	   	if(item.name=='QS'){
	   		if(this.queryParams.qs == item.quer){
	   			console.log('3333333')
	   			this.queryParams.qs=''
	   			return
	   		}
	   		this.queryParams.qs = item.quer
	   		
	   		this.queryParams.ruanke = ''
	   		this.queryParams.xiaoyouhui=''
	   		// this.queryParams.qs=''
	   		this.queryParams.us=''
	   	}
	   	if(item.name=='US'){
	   		if(this.queryParams.us == item.quer){
	   			console.log('3333333')
	   			this.queryParams.us=''
	   			return
	   		}
	   		this.queryParams.us = item.quer
	   		
	   		this.queryParams.qs = ''
	   		this.queryParams.ruanke = ''
	   		this.queryParams.xiaoyouhui=''
	   	}
	   	
	   },
	   clickF(item){
		   if(item.name=='101计划'){
		   	if(this.queryParams.oneJihuas == item.quer){
		   		console.log('1111111111')
		   		this.queryParams.oneJihuas=''
		   		return
		   	}
		   	this.queryParams.oneJihuas = item.quer
		   }
		   if(item.name=='卓越工程师'){
		   	if(this.queryParams.zuoyueJihuas == item.quer){
		   		console.log('2222222')
		   		this.queryParams.zuoyueJihuas=''
		   		return
		   	}
		   	this.queryParams.zuoyueJihuas = item.quer
		   }
		   if(item.name=='国优计划'){
		   	if(this.queryParams.youJihuas == item.quer){
		   		console.log('3333333')
		   		this.queryParams.youJihuas=''
		   		return
		   	}
		   	this.queryParams.youJihuas = item.quer
		   }
	   },
	   
	   schGet(){
		   this.queryParams.pageNum = 1;
		   this.getBath()
	   },
	   // handleScroll(e) {
		  //  console.log('11111',e)
	   //       const bottomOffset = 50; // 距离底部多少像素时触发加载
	   //       const scrollContainer = this.$refs.scrollContainer;
	   //       if (scrollContainer.scrollHeight - (scrollContainer.scrollTop + scrollContainer.clientHeight) < bottomOffset) {
	   //         this.getList();
	   //       }
	   //     },
	   // 数据列表请求
	   getList(type){
		   let qu = {
			   schoolName:this.queryParams.schoolName,
			   // city:this.addShowData.cityId=='全国'?'':this.addShowData.cityId,
			   pageNum:this.queryParams.pageNum,
			   // currentPage:this.news_page,
			   // size:5,
			   pageSize:10,
			   natureName:this.queryParams.natureName.toString()||'',
			   attribute:this.queryParams.attribute.toString()||'',
			   schoolType:this.queryParams.schoolType||'',
			   schoolCityOne:this.queryParams.schoolCityOne.toString()||'',
			   oneJihuas:this.queryParams.oneJihuas?'是':'',
			   zuoyueJihuas:this.queryParams.zuoyueJihuas?'是':'',
			   youJihuas:this.queryParams.youJihuas?'是':'',
			   
			   ruanke:this.queryParams.ruanke?1:0,
			   xiaoyouhui:this.queryParams.xiaoyouhui?1:0,
			   // wushulian:this.queryParams.wushulian?'是':'',
			   qs:this.queryParams.qs?1:0,
			   us:this.queryParams.us?1:0,
			   schoolLevel:this.queryParams.schoolLevel,//本科或者专科
		   }
		   
		   
		    this.api.homeSchoolListApi(qu).then(res => {
				if(res.code==200){
					
					if (type == 'more') {
						if (!res.data) {
							this.$message({
								message: '没有更多了',
								type: 'warning',
								duration: '4000'
							});
							return
						}
						this.schList = [...this.schList, ...res.data.rows];
						
					}else{
						this.schList = []
						this.schList = res.data ? res.data.rows : [];
						// this.dataText = res.data ? '' : '暂无数据'; //进去页面先让字样为空
						this.pageTotal = res.data ? res.data.pageTotal : 0;
					}
					
					
					// if(res.data&&res.data.rows){
					// 	this.pageTotal = res.data.pageTotal
					// 	this.schList = res.data.rows;
						
					// 	// this.schList = [...this.schList, ...res.data.rows];
						
					// }else{
					// 	this.schList = []
					// }
				}else{
					 this.$message.error(res.msg);
				}
			})
	   }
  },
};
</script>

<style lang="scss" scoped>
.img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}


.box{
	/deep/.el-form-item__content{
		flex: 1;
	}
	.el-form-item--small.el-form-item {
		margin-bottom: 5px;
	}
	// height: 100vh;
	// min-height: 30vh;
	.boxA{
		background: #fff;
		border-radius: 10px;
		padding: 10px 20px 20px 20px;
		margin-top: 10px;
		.box-tit{
			width: 100%;
			height: 40px;
			line-height: 40px;
			border-bottom: 1px solid #F44F4D;
			margin-bottom: 15px;
			span{
				width: 140px;
				height: 40px;
				line-height: 40px;
				background-color: #F44F4D;
				color: #fff;
				display: block;
				border-radius: 10px 10px 0 0;
				text-align: center;
				font-size: 15px;
			}
		}
		
		.search-t{
			width: 30%;
			margin-bottom: 10px;
			.input-with-select{
				border-radius: 4px;
				/deep/.el-input__inner{
					border-color: #F56C6C!important;
				}
				/deep/.el-button--danger{
					border: none!important;
				}
				/deep/.el-button{
					border: 1px solid #f44f4d!important;
					background: #f44f4d;
					color: #fff;
					border-radius: 0  4px 4px 0px;
				}
			}
		}
		
		.topsec{
			
			.kuai{
				display: flex;
				flex-wrap: wrap;
				span{
					margin-right: 20px;
					cursor: pointer;
				}
				span.onsele{
					color: #F44F4D;
				}
			}
			.el-form-item {
				display: flex;
			}
		}
	}
	
	// <div class="schmain">
	// 	<div class="sch-ul">
	// 		<div class="sch-li">
	// 			<div class="schli-l"><img src="../../assets/1.png" alt="" /></div>
	// 			<div class="schli-r">
	// 				<div class="schli-rt"><span class="schli-rt-a">天津大学</span><span class="schli-rt-b">dizhi</span></div>
	// 				<div class="schli-rb"><span>benke </span></div>
	// 			</div>
	// 		</div>
	// 	</div>
	// </div>
	.schmain{
		    margin-top: 12px;
		    background: #fff;
		    padding: 10px;
		    border-radius: 10px;
		.sch-ul{
			.sch-li:hover{
				.schli-rt-a{
					color: #F44F4D;
				}
			}
			.sch-li{
				
				background: #fff;
				margin-bottom: 10px;
				display: flex;
				align-items: center;
				padding: 20px;
				border-radius: 10px;
				cursor: pointer;
				.schli-l{
					width: 60px;
					height: 60px;
					margin-right: 20px;
					img{
						width: 60px;
						height: 60px;
						border-radius: 50%;
					}
				}
				.schli-r{
					flex: 1;
					.schli-rt{
						display: flex;
						align-items: center;
						margin-bottom: 10px;
						.schli-rt-a{
							font-size: 22px;
						}
						.schli-rt-b{
							margin-left: 10px;
							    height: 25px;
								line-height: 25px;
							    border-radius: 26px;
							    border: 1px solid #d8d8d8;
							    padding: 0 10px;
							    font-size: 12px;
							    color: #666;
						}
					}
					.schli-rb{
						margin-top: 6px;
						span{
							    height: 22px;
							    padding: 0 8px;
							    border-radius: 4px;
							    background: #f5f6f7;
							    font-size: 14px;
							    color: #666;
							    margin-right: 8px;
						}
					}
				}
			}
		}
	}
}
.admit-scoreLine-box-table-th{
				margin-bottom: 10px;
			}
			.admit-scoreLine-box-table-list{
				width: 100%;
				display: flex;
				.admit-scoreLine-box-table-list-div{
					flex: 1;
					// margin-bottom: 6px;
					font-size: 13px;
					text-align: center;
					line-height: 40px;
					    border-bottom: 1px solid #f0f0f0;
				}
				
			}
.admit-scoreLine-box-table-th-div{
	font-size: 14px;
	text-align: center;
}
</style>